export default __webpack_public_path__ + "static/media/logoMaintenance.0fd83d53.png";